class Modal {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniModal()
    }

    _iniModal() {
        this.modal = this.element.querySelector('.s-modal')
        this.modalEmployees = this.modal.querySelectorAll('.s-employees__modal__item')

        this.element.querySelectorAll('.b-employee').forEach((i) => {
            i.addEventListener('click', (e) => {
                e.preventDefault()

                const modalItemId = e.currentTarget.getAttribute('href')

                if (this.modal.querySelector(modalItemId)) {
                    this.modalEmployees.forEach((i) => {
                        i.style.display = 'none'
                    })

                    setTimeout(() => {
                        this.modal.querySelector(modalItemId).style.display = 'block'

                        setTimeout(() => {
                            this.modal.Modal.open()
                        })
                    })
                }
            })
        })
    }
}

export default Modal
